/* @flow */

import React from "react";
import { Link } from "react-router-dom";

import styles from "./styles.scss";

type Props = {
  item: Block,
};

export type Block = {
  name: string,
  image?: { x1?: string, x2?: string },
  url: string,
  description?: string,
};

const Category = ({ item }: Props): React$Node => {
  return (
    <Link
      to={{
        pathname: item.url,
        state: { hint: { type: "category", category: item } },
      }}
      className={styles.category}
    >
      {item.image &&
        <picture className={styles.image}>
          <source srcSet={`${item.image.x1 ?? ""}, ${item.image.x2 ?? ""} 2x`} />
          <img src={item.image.x1} alt={item.name} />
        </picture>}
      <h3>{item.name}</h3>
    </Link>
  );
};

export default Category;
